import { Button } from "@/components/ui/button";

const ErrorPage = () => {
  return (
    <main className="h-screen flex justify-center items-center font-bold text-3xl">
      <div className="flex justify-center flex-col gap-5">
        <h1>에러가 발생했습니다!</h1>
        <Button
          onClick={() => window.location.reload()}
          className="text-xl"
          size={"lg"}
        >
          다시시도
        </Button>
      </div>
    </main>
  );
};

export default ErrorPage;
